import snail from 'assets/image/snail-catches.png'
import { useActionCreators, useAppSelector } from 'shared/hooks'

import { actions, selectors } from '../../slice'

export function Attention() {
	const message = useAppSelector(selectors.message)
	const { resetSnack } = useActionCreators(actions)
	return (
		<div className='snackbar-notification-attention__message'>
			<img
				alt='snail'
				className='snackbar-notification-attention__icon'
				height={80}
				src={snail}
				width={120}
			/>
			<div className='snackbar-notification-attention__body'>
				<div className='snackbar-notification-attention__title'>
					<span>{message.title}</span>
					<div
						className='snackbar-notification-attention__icon-close'
						onClick={() => resetSnack()}
					/>
				</div>
				<div
					className='snackbar-notification-attention__text'
					dangerouslySetInnerHTML={{ __html: message.content }}
				/>

				{message.button && (
					<div className='notification-button-attention'>
						<a
							className='btn-attention'
							href={message.button.link}
							rel='noopener noreferrer'
							target='_blank'
						>
							{message.button.title}
						</a>
					</div>
				)}
			</div>
		</div>
	)
}
